// Variant Selection and Sticky ATC Synchronization logic for EUROPECASE

document.addEventListener('DOMContentLoaded', () => {
  const wrappers = document.querySelectorAll('.brand-model-selector-wrapper');
  wrappers.forEach(wrapper => {
    initProductOptions(wrapper);
  });
});

function initProductOptions(wrapper) {
  const sectionId = wrapper.getAttribute('id').replace('brand-model-selector-', '');
  const brandIndex = parseInt(wrapper.getAttribute('data-brand-index'));
  const modelIndex = parseInt(wrapper.getAttribute('data-model-index'));
  const colorIndexAttr = wrapper.getAttribute('data-color-index');
  const colorIndex = colorIndexAttr !== null ? parseInt(colorIndexAttr) : -1;

  // Retrieve variant map
  const jsonElement = document.getElementById(`VariantJson-${sectionId}`);
  if (!jsonElement) return;
  const variants = JSON.parse(jsonElement.textContent);

  // Selector elements
  const brandButtons = document.querySelectorAll(`#brand-swatches-${sectionId} .brand-swatch-btn`);
  const modelSelect = document.getElementById(`model-select-${sectionId}`);
  const colorButtons = document.querySelectorAll(`#color-swatches-${sectionId} .color-swatch-btn`);
  const colorLabel = document.getElementById(`selected-color-name-${sectionId}`);
  const hiddenInput = document.getElementById(`ProductSelect-${sectionId}`);
  
  // Display elements
  const priceDisplay = document.getElementById(`price-display-${sectionId}`);
  const comparePriceDisplay = document.getElementById(`compare-price-display-${sectionId}`);
  const discountBadge = document.getElementById(`discount-badge-${sectionId}`);
  const mainProductImg = document.getElementById(`main-product-img-${sectionId}`);
  const addToCartBtn = document.getElementById(`add-to-cart-btn-${sectionId}`);
  const addToCartText = document.getElementById(`add-to-cart-text-${sectionId}`);

  // Sticky ATC elements
  const stickyImg = document.getElementById('sticky-atc-img');
  const stickyVariant = document.getElementById('sticky-atc-variant');
  const stickyPrice = document.getElementById('sticky-atc-price');

  let selectedBrand = '';
  let selectedModel = '';
  let selectedColor = '';

  // Get active brand from initial state
  const activeBrandBtn = document.querySelector(`#brand-swatches-${sectionId} .brand-swatch-btn.border-brand`);
  if (activeBrandBtn) {
    selectedBrand = activeBrandBtn.getAttribute('data-value');
  }

  // Get active color from initial state
  if (colorIndex > -1) {
    const activeColorBtn = document.querySelector(`#color-swatches-${sectionId} .color-swatch-btn.active-ring`);
    if (activeColorBtn) {
      selectedColor = activeColorBtn.getAttribute('data-value');
    }
  }

  // A. Filter Models based on Selected Brand
  const filterModels = (brand) => {
    if (!modelSelect) return;
    
    // Find all models that exist for this brand
    const availableModels = new Set();
    variants.forEach(variant => {
      if (variant.options[brandIndex] === brand) {
        availableModels.add(variant.options[modelIndex]);
      }
    });

    // Populate modelSelect
    modelSelect.innerHTML = '';
    availableModels.forEach(model => {
      const option = document.createElement('option');
      option.value = model;
      option.textContent = model;
      modelSelect.appendChild(option);
    });

    // Pre-select first available model
    if (availableModels.size > 0) {
      selectedModel = modelSelect.value;
    } else {
      selectedModel = '';
    }
  };

  // Run initial model filter
  if (selectedBrand) {
    filterModels(selectedBrand);
  }

  // B. Event Listeners
  // Brand swatches click
  brandButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      brandButtons.forEach(b => {
        b.classList.remove('border-brand', 'border-2', 'text-brand');
        b.classList.add('border-line', 'text-muted');
      });
      btn.classList.add('border-brand', 'border-2', 'text-brand');
      btn.classList.remove('border-line', 'text-muted');

      selectedBrand = btn.getAttribute('data-value');
      filterModels(selectedBrand);
      updateSelectedVariant();
    });
  });

  // Model select change
  if (modelSelect) {
    modelSelect.addEventListener('change', () => {
      selectedModel = modelSelect.value;
      updateSelectedVariant();
    });
  }

  // Color swatches click
  if (colorIndex > -1) {
    colorButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        colorButtons.forEach(b => b.classList.remove('active-ring'));
        btn.classList.add('active-ring');

        selectedColor = btn.getAttribute('data-value');
        if (colorLabel) {
          colorLabel.textContent = selectedColor;
        }
        updateSelectedVariant();
      });
    });
  }

  // C. Update UI based on matched variant
  function updateSelectedVariant() {
    // Find matched variant
    const matchedVariant = variants.find(variant => {
      const brandMatch = variant.options[brandIndex] === selectedBrand;
      const modelMatch = variant.options[modelIndex] === selectedModel;
      const colorMatch = colorIndex === -1 || variant.options[colorIndex] === selectedColor;
      return brandMatch && modelMatch && colorMatch;
    });

    if (matchedVariant) {
      // 1. Update ID Input
      if (hiddenInput) {
        hiddenInput.value = matchedVariant.id;
      }

      // 2. Update Prices
      if (priceDisplay) {
        priceDisplay.textContent = matchedVariant.price_formatted;
      }
      
      if (comparePriceDisplay) {
        if (matchedVariant.compare_at_price > matchedVariant.price) {
          comparePriceDisplay.textContent = matchedVariant.compare_at_price_formatted;
          comparePriceDisplay.classList.remove('hidden');
        } else {
          comparePriceDisplay.classList.add('hidden');
        }
      }

      // 3. Discount Badge
      if (discountBadge) {
        if (matchedVariant.compare_at_price > matchedVariant.price) {
          const discount = Math.round(((matchedVariant.compare_at_price - matchedVariant.price) / matchedVariant.compare_at_price) * 100);
          discountBadge.textContent = `%${discount} OFF`;
          discountBadge.classList.remove('hidden');
        } else {
          discountBadge.classList.add('hidden');
        }
      }

      // 4. Variant Image
      if (mainProductImg && matchedVariant.featured_image) {
        mainProductImg.src = matchedVariant.featured_image;
        
        // Also update thumbnail list active state if matches
        const thumbItems = document.querySelectorAll(`#thumb-gallery-${sectionId} .thumb-item`);
        thumbItems.forEach(thumb => {
          if (thumb.getAttribute('data-img') === matchedVariant.featured_image) {
            thumbItems.forEach(t => t.classList.remove('border-brand', 'border-2'));
            thumb.classList.add('border-brand', 'border-2');
          }
        });
      }

      // 5. Button States
      if (addToCartBtn) {
        if (matchedVariant.available) {
          addToCartBtn.removeAttribute('disabled');
          addToCartBtn.classList.remove('bg-surface-container-high', 'text-muted', 'cursor-not-allowed');
          addToCartBtn.classList.add('bg-brand', 'hover:bg-brand-dk', 'text-white');
          if (addToCartText) addToCartText.textContent = 'SEPETE EKLE';
        } else {
          addToCartBtn.setAttribute('disabled', 'true');
          addToCartBtn.classList.add('bg-surface-container-high', 'text-muted', 'cursor-not-allowed');
          addToCartBtn.classList.remove('bg-brand', 'hover:bg-brand-dk', 'text-white');
          if (addToCartText) addToCartText.textContent = 'STOKTA YOK';
        }
      }

      // 6. Sync with Sticky ATC
      if (stickyImg && matchedVariant.featured_image) {
        stickyImg.src = matchedVariant.featured_image;
      }
      if (stickyVariant) {
        stickyVariant.textContent = matchedVariant.title;
      }
      if (stickyPrice) {
        stickyPrice.textContent = matchedVariant.price_formatted;
      }
    } else {
      // Disable add to cart if no match is found
      if (addToCartBtn) {
        addToCartBtn.setAttribute('disabled', 'true');
        if (addToCartText) addToCartText.textContent = 'SEÇENEK UYUMLU DEĞİL';
      }
    }
  }

  // Run once initially
  updateSelectedVariant();
}
